module.exports = __webpack_public_path__ + "img/assessment_result.646868d5.jpeg";